import React from 'react';
import { ZoomPlot } from '../../plot/components/ZoomPlot';
import { useQRSListener } from '../hooks/useQRSListener';
import { ThreeLeadPlotContainer } from '../../plot/components/ThreeLeadPlotContainer';

export const QrsAnnotation: React.FC = () => {
  useQRSListener();

  return (
    <>
      <ZoomPlot />
      <ThreeLeadPlotContainer />
    </>
  );
};
